import { Container, Row } from "reactstrap";
import { KnowledgeBaseTitle } from "../../../constants";
import { LatestArticlesVideosKnowledge } from "../../../data/miscellaneous/FAQ";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import KnowledgeSearch from "./KnowledgeSearch";
import FaqWidgets from "../faq/FaqWidgets";
import BrowseArticles from "./BrowseArticles";
import FeaturedTutorials from "../faq/FeaturedTutorials";
import LatestArticlesVideos from "../faq/LatestArticlesVideos";

const KnowledgeBaseContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={KnowledgeBaseTitle} parent={KnowledgeBaseTitle} />
      <Container fluid className="knowledgebase">
        <Row>
          <KnowledgeSearch />
          <FaqWidgets />
          <BrowseArticles />
          <FeaturedTutorials />
          <LatestArticlesVideos data={LatestArticlesVideosKnowledge} />
        </Row>
      </Container>
    </>
  );
};
export default KnowledgeBaseContainer;
